import React, { FC, useState } from 'react'
import { CouponItem } from '@cps'
import './index.scss'

// interface
interface IProps {
  coupons: any;
  couponDetails: any;
  count: number;
  title: string;
  text?: string;
  onClick: () => void;
  shareText?: string;
}

const Text: FC<IProps> = (props: IProps) => {
  const { coupons, couponDetails, count, title, text, shareText, onClick } = props
  const [showAll, setShowAll] = useState<boolean>(false)
  const getShowAll = () => {
    if (coupons.length > 3) {
      setShowAll(!showAll)
    }
  }
  return (
    <div className='invitation-coupons'>
      {
        shareText && <div className='share-text' dangerouslySetInnerHTML={{ __html: shareText }}></div>
      }
      {
        Object.keys(couponDetails).length > 0 && coupons.map((item: any, index: number) => {
          const hasItem: any = couponDetails[item.couponId]
          return hasItem && (
            (showAll ? index < coupons.length : index < 3) &&
              <div className='coupon-block' key={`${index}-${item.couponId}`}>
                <CouponItem type='get' couponInfo={hasItem} cnt={item.couponCnt > 1 ? item.couponCnt : ''}></CouponItem>
              </div>
          )
        })
      }
      {
        coupons.length > 3 && <div className='coupons-num' onClick={getShowAll}>{showAll ? i18n.t('mkt.activity.hide', { count: count }) : i18n.t('mkt.activity.showAll', { count: count })}</div>
      }
      <div className='button' onClick={onClick}>
        {/* <i className='iconfont icon-duomeitiicon'></i> */}
        <span>{title}</span>
      </div>
      {
        text && <div className='tip'>{text}</div>
      }
    </div>
  )
}

export default Text
